import db from "src/lib/dexie-db/db";
import { mergeConfigs } from "../utils/config";
export default async function getConfig(userID, nodeID) {
    const node = await db.qnaNode.get(nodeID);
    if (!node) {
        throw new Error('Node not found');
    }
    // Get all ancestors in order (from root to immediate parent)
    const ancestors = await db.qnaNode
        .where('_id')
        .anyOf(node.ancestors)
        .toArray();
    // Sort ancestors by their position in the ancestors array (closest to root first)
    const sortedAncestors = node.ancestors.map(ancestorID => ancestors.find(ancestor => ancestor._id === ancestorID)).filter(Boolean);
    // Start with an empty config
    let mergedConfig = {};
    // Merge configs from ancestors (from root to immediate parent)
    // This follows the same pattern as TreeModel.getConfig where ancestor configs are merged first
    for (const ancestor of sortedAncestors) {
        if (ancestor?.config) {
            mergedConfig = mergeConfigs(mergedConfig, ancestor.config);
        }
    }
    // Finally, merge the current node's config (which takes precedence)
    if (node.config) {
        mergedConfig = mergeConfigs(mergedConfig, node.config);
    }
    return mergedConfig;
}
